import React, { Component } from 'react';
import * as dateUtils from '../../util/dateUtil';
import SelectList from "./SelectList";

class DateTimeInputNew extends Component {
    constructor(props) {
        super(props);

        this.controlDateTime = this.controlDateTime.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            this.props.initDate !== nextProps.initDate
            || this.props.date !== nextProps.date
            || this.props.hour !== nextProps.hour
            || this.props.minute !== nextProps.minute
        )
    }

    async controlDateTime(id, value) {
        const { changeValue } = this.props;
        const { date, hour, minute } = this.props;

        switch (id) {
            case "date":
                const date1 = new Date(value);
                if (dateUtils.isHoliday(date1) || dateUtils.isWeekend(date1)) {
                    alert("발송 일자를 주말, 공휴일로 설정 하셨습니다.\n 주말 및 공휴일 발송 시 기재하신 고객센테에서 CS 처리가 가능하여야 합니다.")
                }
                changeValue("sendDate", `${value} ${hour}:${minute}`)
                break;
            case "hour":
                changeValue("sendDate", `${date} ${value}:${minute}`)
                break;
            case "minute":
                changeValue("sendDate", `${date} ${hour}:${value}`)
                break;
            default:
                break;
        }
    }

    render() {
        const { className } = this.props;
        const { date, hour, minute, initDate } = this.props;

        const { controlDateTime } = this;

        return(
            <div className={'d-flex flex-column flex-md-row'}>
                <input type="date" className={className} min={initDate}
                       value={date} onChange={(e) => controlDateTime("date", e.target.value)}/>

                <div className={'d-flex'}>
                    <SelectList
                        className="form-select d-inline w-auto"
                        id="hour"
                        value={hour}
                        list={dateUtils.hourList}
                        onChange={controlDateTime}
                        disableDefault={true}
                    />
                    <span className='mt-1 mx-1'>시</span>
                    <SelectList
                        className="form-select d-inline w-auto"
                        id="minute"
                        onChange={controlDateTime}
                        value={minute}
                        list={dateUtils.minuteList}
                        disableDefault={true}
                    />
                    <span className='mt-1 mx-1'>분</span>
                </div>
            </div>
        )
    }
}

export default DateTimeInputNew;
